'use client';

import { useRef } from 'react';

import Script from 'next/script';

import { format } from 'date-fns';

import { cn } from '@/lib/utils/cn';

export interface TonicWidgetProps {
  itemIds: string;
  date: string;
  affiliateId?: string;
  useLatest?: boolean;
  className?: string;
  containerId?: string;
}

export const TonicWidget = ({ itemIds, date, affiliateId, className, containerId, useLatest }: TonicWidgetProps) => {
  const formattedDate = format(new Date(date), 'yyyyMMdd');
  const containerRef = useRef<HTMLDivElement | null>(null);

  const params = new URLSearchParams({
    'item-ids': itemIds,
    // occurrence doesn't work with v2 yet
    ...(!useLatest ? { occurrence: formattedDate } : {}),
    'affiliate-id': affiliateId || '',
    // this is used to force the script to reload on re-render such as when the booking sheet is opened
    loaded: new Date().toISOString(),
  });

  const url = `https://widgets.designmynight.com/tonic/ticket-widget${useLatest ? '-v2' : ''}.min.js?${params}`;

  if (!itemIds) return null;

  const appendScript = () => {
    if (!containerRef.current) return;

    // Move script output to the desired container after it loads
    console.log('Getting script');
    const scriptOutput =
      document.getElementById('dmn-ticket-selection') || document.getElementById('tonic-ticket-widget');

    if (scriptOutput) {
      console.log('Appending script');
      containerRef.current.appendChild(scriptOutput);
    }
  };

  return (
    <>
      <div ref={containerRef} id={containerId || 'tonic-container'} className={cn('w-full', className)} />

      <Script
        data-dmn-ticket-widget
        src={url}
        onLoad={() => {
          appendScript();
          console.log('Script loaded successfully');
        }}
        onError={() => console.error('Failed to load the script')}
      />
    </>
  );
};
